import { createAsyncThunk } from '@reduxjs/toolkit';

import { Location } from 'core/universalRouter/types';

import type { RootState, ThunkDependencies } from 'react-redux';

const toLocationObject = (to: Location | string) => {
  if (typeof to === 'string') {
    const [pathname, search] = to.split('?');

    return new Location({ pathname, search });
  }

  return to;
};

export const pushLocation = createAsyncThunk<
  void, // Return type
  Location | string, // Argument type
  {
    state: RootState;
    extra: ThunkDependencies;
  }
>('router/pushLocation', async (to, { getState, extra: { history, res } }) => {
  const { baseUrl } = getState().router;

  to = toLocationObject(to);

  if (history) {
    history.push(to);
  } else if (res) {
    let path = to.pathname || '/';

    if (to.search) path = path + '?' + to.search;
    res.redirect(baseUrl + path);
  }
});

export const replaceLocation = createAsyncThunk<
  void, // Return type
  Location | string, // Argument type
  {
    state: RootState;
    extra: ThunkDependencies;
  }
>('router/replaceLocation', async (to, { extra: { history } }) => {
  if (history) {
    history.replace(toLocationObject(to));
  }
});

export const backLocation = createAsyncThunk<
  void,
  void,
  {
    extra: ThunkDependencies;
  }
>('router/backLocation', async (_, { extra: { history } }) => {
  if (history) {
    history.goBack();
  }
});
